<ng-container *transloco="let t; prefix: 'fuelShared'">
@if (tooltipType && tooltipData && (tooltipType === 'tank-card')) {
<div id="tooltip_{{ tooltipData._id }}">
  <div class="tooltip-overlay"></div>
  <div class="tank-tooltop-card">
    <p class="title">{{ tooltipData.title }}</p>
    <ul>
      <li class="d-flex justify-content-between align-items-center">
        <p class="light-text">{{ t('tooltip.location') }}</p>
        <p class="dark-text">{{ tooltipData.location }}</p>
      </li>
      <li class="d-flex justify-content-between align-items-center">
        <p class="light-text">{{ t('tooltip.lastReading') }}</p>
        <p class="dark-text">{{ tooltipData.lastReading }}</p>
      </li>
      <li class="d-flex justify-content-between align-items-center">
        <p class="light-text">
          {{ t('tooltip.volume') }} <span class="span-bld-text">{{ t('tooltip.volumeUnit') }}</span>
        </p>
        <p class="green-text">{{ tooltipData.volume }}</p>
      </li>
      <li class="d-flex justify-content-between align-items-center">
        <p class="light-text">{{ t('tooltip.percentage') }}</p>
        <p class="dark-text">{{ tooltipData.percentage }}</p>
      </li>
      <li class="d-flex justify-content-between align-items-center">
        <p class="light-text">
          {{ t('tooltip.temperature') }} <span class="span-bld-text">{{ t('tooltip.temperatureUnit') }}</span>
        </p>
        <p class="dark-text">{{ tooltipData.temperature }}</p>
      </li>
      <li class="d-flex justify-content-between align-items-center">
        <p class="light-text">{{ t('tooltip.status') }}</p>
        <p class="dark-text">{{ tooltipData.status }}</p>
      </li>
      <li class="d-flex justify-content-between align-items-center">
        <p class="light-text">{{ t('tooltip.action') }}</p>
        <button class="view-btn">{{ tooltipData.action }}</button>
      </li>
    </ul>
  </div>
</div>
}
</ng-container>